exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.overview-metric-tip {\n  max-width: 360px;\n  line-height: 1.6;\n}\n", ""]);

// exports
